$(function() {

  /**
   * /sensha/以下の場合にだけナビゲーションを表示する。
   */
  var stDrawerItem = (function() {
    var dir = location.pathname.split("/");
    var url = dir[1];
    if(url !== 'sensha') {
      $('.st-Drawer_Item-sensha').hide();
    }
  })();


}());
